import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useCallback } from "react";
import { FormFieldTypes } from "types/enums";

const FORM_FIELD_TYPE_KEY: Record<string, string> = {
    [FormFieldTypes.Text]: "text",
    [FormFieldTypes.Number]: "number",
    [FormFieldTypes.Checkbox]: "checkbox",
    [FormFieldTypes.Date]: "date",
    [FormFieldTypes.Select]: "select",
    [FormFieldTypes.Radio]: "radio",
    [FormFieldTypes.Phone]: "phone",
    [FormFieldTypes.Email]: "email",
    [FormFieldTypes.OnlyText]: "only_text",
    [FormFieldTypes.Country]: "country",
    [FormFieldTypes.IdentityCardNumber]: "identity_card_number",
    [FormFieldTypes.Nin]: "nin",
    [FormFieldTypes.CheckboxTerms]: "checkbox_terms",
    [FormFieldTypes.IpId]: "ip_id",
    [FormFieldTypes.BuildFullBankAccount]: "build_full_bank_account",
    [FormFieldTypes.AccessToken]: "access_token",
    [FormFieldTypes.NinOnlyNumber]: "nin_only_number",
    [FormFieldTypes.Slider]: "slider",
    [FormFieldTypes.SliderMoney]: "slider_money",
    [FormFieldTypes.PhoneCz]: "phone_cz",
    [FormFieldTypes.UserAgent]: "user_agent",
    [FormFieldTypes.IpAddress]: "ip_address",
    [FormFieldTypes.BankCode]: "bank_code",
    [FormFieldTypes.BankAccount]: "bank_account",
    [FormFieldTypes.CzZip]: "cz_zip",
    [FormFieldTypes.CzkPrice]: "czk_price",
    [FormFieldTypes.OnlyNumber]: "only_number",
    [FormFieldTypes.HouseNumber]: "house_number",
    [FormFieldTypes.CreatedDate]: "created_date",
    [FormFieldTypes.TextTitle]: "text_title",
    [FormFieldTypes.CustomHtml]: "custom_html",
    [FormFieldTypes.Spacing]: "spacing",
};

export const useFormFieldTypeLabel = () => {
    const { t } = usePaldockTranslation("enums.form-field-types");

    return useCallback(
        (type: FormFieldTypes | string | null | undefined): string => {
            if (!type) return "";
            const key = FORM_FIELD_TYPE_KEY[type as FormFieldTypes];
            return key ? t(key) : String(type);
        },
        [t]
    );
};
